<script setup>
import { onMounted } from 'vue';
import OpenAIProvider from './providers/OpenAI.vue';
import OllamaProvider from './providers/Ollama.vue';
import OpenRouterProvider from './providers/OpenRouter.vue';
import Select from '../../../library/form/components/Select.vue';

// Stores
import { useSettingsStore } from '../stores/settings';

const { labels } = window.DATAGENT_PLUGIN_SETTINGS;

// Get the settings store
const settingsStore = useSettingsStore();

// Handle provider change
const handleProviderChange = (e) => {
  if (e?.target?.value) {
    settingsStore.selectedProvider = e.target.value;
  }
};
</script>

<template>
  <form id="dataagent-settings-form" class="dataagent-settings-form da:mb-4" @submit.prevent>
    <!-- START: API Configuration -->
    <section class="dataagent-settings-section da:mb-5 da:p-5">
      <div class="da:mb-4">
        <table class="form-table">
          <tr>
            <th scope="row">
              <label for="dataagent_provider" class="da:block da:text-sm da:font-medium da:text-gray-700">{{
                labels.provider
              }}</label>
            </th>
            <td>
              <Select
                id="dataagent_provider"
                @change="handleProviderChange"
                class="da:w-full md:da:w-[250px] da:px-3 da:py-2 da:border da:border-gray-300 da:rounded-md da:shadow-sm da:focus:outline-none da:focus:ring-[#4CB21A] da:focus:border-[#4CB21A] da:cursor-pointer"
                :options="
                  settingsStore.providers.map((p) => ({
                    id: p.value,
                    text: p.label,
                  }))
                "
                :value="settingsStore.selectedProvider"
              />
              <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">{{ labels.provider_description }}</p>
            </td>
          </tr>
        </table>
      </div>

      <!-- AI Providers Settings -->
      <OpenAIProvider />
      <OllamaProvider />
      <OpenRouterProvider />

      <!-- Save Button -->
      <div class="submit da:mt-6 da:flex">
        <button
          type="button"
          @click="settingsStore.saveSettings"
          class="da:inline-flex da:items-center da:justify-center da:px-5 da:py-2.5 da:bg-[#4CB21A] da:text-white da:text-sm da:font-medium da:rounded-lg da:shadow-md da:hover:bg-[#3A8E15] da:focus:outline-none da:focus:ring-2 da:focus:ring-offset-2 da:focus:ring-[#4CB21A] da:transition da:duration-200 da:cursor-pointer"
          :disabled="settingsStore.saveSettingsLoading"
        >
          <svg
            v-if="settingsStore.saveSettingsLoading"
            class="da:animate-spin da:-ml-1 da:mr-2 da:h-4 da:w-4 da:text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle class="da:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path
              class="da:opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          {{ settingsStore.saveSettingsLoading ? labels.saving : labels.save_settings }}
        </button>
      </div>
    </section>
  </form>
</template>
